import { useTranslation } from 'react-i18next';

export function HistorieTrigger() {
  const { t } = useTranslation();
  return <div>{t('domain.arbeitszeiten.sheet.tabs.historie')}</div>;
}
